<template>
    <Modal width="450"
           v-model="detailModal"
           :title="$t('personalInformation')"
    >
        <div class="person-detail" style="min-height:500px;">
            <ul>
                <li v-if="role=='merchant'">
                    <p><label class="title-label">{{$t('merchant.username')}}：</label>
                        <label class="value-label cb-class">
                            {{merchant.account}}
                        </label>
                    </p>
                    <p><label class="title-label">{{$t('agent.nickname')}}：</label>
                        <label class="value-label ">
                            {{merchant.nickname}}
                        </label>
                    </p>
                    <p><label class="title-label">{{$t('agent.balance')}}：</label>
                        <label class="value-label cb-class">
                            {{merchant.balance}}
                        </label>
                        <!--</label>&nbsp;&nbsp;&nbsp;&nbsp;(单位：元)-->
                    </p>
                    <p><label class="title-label">{{$t('merchant.shopName')}}：</label>
                        <label class="value-label ">
                            {{merchant.shopName}}
                        </label>
                    </p>
                    <p><label class="title-label">{{$t('common.contact')}}：</label>
                        <label class="value-label ">
                            {{merchant.linkman}}
                        </label>
                    </p>
                    <p><label class="title-label">{{$t('common.phone')}}：</label>
                        <label class="value-label ">
                            {{merchant.phone}}
                        </label>
                    </p>
                    <p><label class="title-label">{{$t('common.address')}}：</label>
                        <label class="value-label ">
                            {{merchant.address}}
                        </label>
                    </p>
                </li>
                <li v-else>
                    <p><label class="title-label">{{$t('merchant.username')}}：</label>
                        <label class="value-label cb-class">
                            {{agent.account}}
                        </label>
                    </p>
                    <p><label class="title-label">{{$t('agent.nickname')}}：</label>
                        <label class="value-label ">
                            {{agent.remark}}
                        </label>
                    </p>
                    <p v-show="isShowBalance"><label class="title-label">{{$t('agent.platform')}}{{$t('agent.balance')}}：</label>
                        <label class="value-label cb-class">
                            {{agent.balance}}
                        <!--</label>&nbsp;&nbsp;&nbsp;&nbsp;(单位：元)-->
                        </label>
                    </p>
                    <p v-show="agent.mgw_balance"><label class="title-label">{{$t('agent.mgw_balance')}}：</label>
                        <label class="value-label cb-class">
                            {{agent.mgw_balance}}
                        </label>
                    </p>
                </li>
            </ul>
        </div>
        <div slot="footer"></div>
        <div style="position:fixed;top:0px;left:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="list_loadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">{{$t('loading')}}</h6>
        </div>
    </Modal>
</template>
<script>
    export default {
         props: ['details'],
        data () {
            return {
                detailModal: false,
                list_loadding: false,
                isShowBalance: false,
                role: '',
                agent: {
                    account: '',
                    remark: '',
                    balance: '',
                    mgw_balance: '',
                },
                merchant: {
                    account: '',
                    nickname: '',
                    shopName: '',
                    balance: '',
                    linkman: '',
                    phone: '',
                    address: ''
                }
            }
        },
        methods:{
            cancel () {

            }
        },
        mounted(){

        },
        watch: {
            details: function () {
                if(this.details) {
                    this.list_loadding = true;
                    var uid  = this.details;
                    this.$emit('closeWin', '');
                    this.$store.dispatch('GetInfo', uid).then((res) => {
                        // 保存取到的所有数据
                        if (res.data.status == 'error') {
                            this.$Message.error(res.message);
                            this.list_loadding = false;
                            return false;
                        }
                        if (this.role!='merchant') {
                            this.agent.account = res.data.agent.account;
                            this.agent.remark = res.data.agent.remark;
                            this.agent.balance = res.data.agent.balance;
                            this.agent.mgw_balance = res.data.agent.mgw_balance;
                        } else  {
                            this.merchant.account = res.data.merchant.account;
                            this.merchant.nickname = res.data.merchant.nickname;
                            this.merchant.balance = res.data.merchant.balance;
                            this.merchant.shopName = res.data.merchant.shopName;
                            this.merchant.linkman = res.data.merchant.linkman;
                            this.merchant.phone = res.data.merchant.phone;
                            this.merchant.address = res.data.merchant.address;
                        }
                        var account = res.data.agent.account;
                        var list = ['sct0325','sct0337','sct0171', 'sct0204', 'sct0296', 'sct0325', 'sct0337'];
                        if(!list.includes(account)){
                            this.isShowBalance = true;
                        }
                        this.list_loadding = false;
                    }).catch(err => {
                        this.$Message.error(err.message);
                        this.list_loadding = false;
                        return false;
                    });
                    this.detailModal = true;
                }
            }
        },
        created(){
            this.role =  this.$store.getters.roles[0];
        }
    }
</script>
<style lang="scss">
    .person-detail p{
        font-size: 14px;
        padding:5px;
        width: 100%;
        float: left;
    }
    .person-detail ul {
        list-style: none;
    }
    .person-detail .addHeaderTitle{
        background-color: #dddddd;
        height: 38px;
        width: 100%;
        padding: 10px;
        margin: 20px 0;
    }

    .value-label {
        float: left;
    }
    .title-label {
        float: left;
        display: block;
        width: 150px;
        font-size: 14px;
        text-align: right;
    }
    .value-label span{
        width: 150px;
    }
    .value-class {
        display: block;
        color: blue;
        text-align: left;
    }


    /* 禁用样式*/
    .cr-class {
        color: red;
    }
    /* 可用样式*/
    .cg-class {
        color: green;
    }
    .cb-class {
        color: blue;
    }
    .cc-class {
        color:coral;
    }
    .cgr-class {
        color: red;
    }
    .expire-class {
        color: orange;
    }
    .prepay-class {
        color: green;
    }
    .postpay-class {
        color: #FF6A6A;
    }
</style>



// WEBPACK FOOTER //
// perDetails.vue?0f2ae725